<template>
	<div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'DetailsViewTab',
	props: {
		id: {
			type: String,
			required: true
		},
		dataLinksTarget: {
			type: String,
			required: true,
			default: null
		}
	},
	data() {
		return {

		}
	},

	provide() {
		return {
			tabId: this.id,
			dataLinksTarget: this.dataLinksTarget
		}
	},

	created() {
		// window.addEventListener('message', this.bryterModuleEventListener)
	},

	methods: {

		
	}

}
</script>